import * as GeneralRepository from "./general-repository";
import * as PagoRecurrenteProvider from "../providers/pago-recurrente-provider";

export const obtenerPagoRecurrente = async (idSolicitudMultiple) => {
    const response = await PagoRecurrenteProvider.obtenerPagoRecurrente(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagoRecurrente: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerPagoRecurrente(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    pagoRecurrente: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagoRecurrente: null
            }
        }
    }
}

export const actualizarPagoRecurrente = async (idSolicitudMultiple, pagoRecurrente, flagMismoMedioPago) => {
    const response = await PagoRecurrenteProvider.actualizarPagoRecurrente(idSolicitudMultiple, flagMismoMedioPago, pagoRecurrente)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagoRecurrente: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await actualizarPagoRecurrente(idSolicitudMultiple, pagoRecurrente, flagMismoMedioPago)
            } else {
                return {
                    error: response.auditResponse,
                    pagoRecurrente: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagoRecurrente: null
            }
        }
    }
}

export const obtenerOperadores = async (idMedioPago) => {
    const response = await PagoRecurrenteProvider.obtenerOperadores(idMedioPago)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            operadores: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerOperadores(idMedioPago)
            } else {
                return {
                    error: response.auditResponse,
                    operadores: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                operadores: null
            }
        }
    }
}

export const validarPagoRecurrente = async (pagoRecurrente, idSolicitudMultiple) => {
    const response = await PagoRecurrenteProvider.validarPagoRecurrente(pagoRecurrente, idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            validacion: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await validarPagoRecurrente(pagoRecurrente, idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    validacion: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                validacion: null
            }
        }
    }
}